// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2hSke","paramInput":"JobSimulator_paramInput__2FtGE","input":"JobSimulator_input__2Iq4l"};